document.addEventListener('DOMContentLoaded', () => {
	if (window.gsap && window.ScrollTrigger) {
		gsap.registerPlugin(ScrollTrigger);
	}

	// ---------------------------------------------
	// ヘッダー高さ → CSS変数 --header-h に反映
	// ---------------------------------------------
	const setHeaderHeightVar = () => {
		const header = document.querySelector('header.mheader');
		if (!header) return;
		const h = header.offsetHeight;
		document.documentElement.style.setProperty('--header-h', `${h}px`);
	};
	setHeaderHeightVar();
	window.addEventListener('resize', setHeaderHeightVar);

	if (document.fonts) {
		document.fonts.ready.then(setHeaderHeightVar);
	}
	const hdr = document.querySelector('header.mheader');
	if (hdr) {
		const observer = new MutationObserver(setHeaderHeightVar);
		observer.observe(hdr, { attributes: true, childList: true, subtree: true });
	}

	// backボタン高さ
	function syncBackbtnHeight() {
		const backBtnHeightEl = document.querySelector('.mega-back');
		if (!backBtnHeightEl) return;

		const backBtnHeight = backBtnHeightEl.offsetHeight;

		document.documentElement.style.setProperty('--backbtn-height', `${backBtnHeight}px`);
	}
	window.addEventListener('load', syncBackbtnHeight);
	window.addEventListener('resize', syncBackbtnHeight);

	// --------------------------------
	// Window高さ
	// --------------------------------
	const setWindowHeight = () => {
		const winH = window.innerHeight;
		document.documentElement.style.setProperty('--window-h', `${winH}px`);
	};
	setWindowHeight();
	window.addEventListener('orientationchange', () => {
		setTimeout(setWindowHeight, 300);
	});

	// --------------------------------
	// ヘッダー色切り替え（.mainmv 上は white / それ以外 black）
	// --------------------------------
	const header = document.querySelector('header.mheader');
	if (header && window.gsap && window.ScrollTrigger) {
		const mainmv = document.querySelector('.mainmv');
		if (mainmv) {
			const setHeaderState = (onMainMv) => {
			if (onMainMv) {
				header.classList.add('white');
				header.classList.remove('black');
			} else {
				header.classList.add('black');
				header.classList.remove('white');
			}
			};

			const isAfterMainMv = () => window.scrollY >= mainmv.offsetHeight;
			setHeaderState(!isAfterMainMv());

			ScrollTrigger.create({
			trigger: mainmv,
			start: 'top top',
			end: 'bottom top',
			onEnter: () => setHeaderState(true),
			onEnterBack: () => setHeaderState(true),
			onLeave: () => setHeaderState(false),
			onLeaveBack: () => setHeaderState(true),
			});
		}
	}

	// --------------------------------
	// メガメニュー（PC = hover / SP = ハンバーガー＋アコーディオン）
	// --------------------------------
	if (header) {
		const body      = document.body;
		const megaLayer = document.querySelector('.mega-layer');
		const panels    = document.querySelectorAll('.mega-panel');
		const pcTriggers = document.querySelectorAll('.nav_item.has_mega');  // PC用
		const spTriggers = document.querySelectorAll('.mega-toggle');        // SP用
		const hamburger  = document.querySelector('.hamburger');

		if (!megaLayer || !panels.length) {
			// メガメニューそのものが無ければ何もしない
		} else {
			const mqPc = window.matchMedia('(min-width: 1120px)');
			let currentId = null;
			let hoverTimer = null;

			const setPanelState = (idOrNull) => {
				currentId = idOrNull;

				panels.forEach((panel) => {
					const isTarget = panel.id === idOrNull;
					panel.classList.toggle('is-open', isTarget);
					panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
				});

				pcTriggers.forEach((btn) => {
					const active = btn.dataset.mega === idOrNull;
					btn.classList.toggle('is-active', active);
				});

				spTriggers.forEach((btn) => {
					const active = btn.dataset.mega === idOrNull;
					btn.classList.toggle('is-active', active);
				});

				//メガメニューのスマホbackボタン
				const backButtons = document.querySelectorAll('.mega-panel .mega-back');
				backButtons.forEach((btn) => {
					btn.addEventListener('click', (e) => {
					e.preventDefault();
					// PCサイズでは何もしない
					if (mqPc.matches) return;

					// パネルだけ閉じる（mega-layer は開いたまま）
					setPanelState(null);

					// メニュー一覧（.mega-nav-sp）までスクロール戻したい場合
					const navSp = document.querySelector('.mega-nav-sp');
					if (navSp) {
						navSp.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
					});
				});
				
			};

			const openMegaPc = (id) => {
			if (!mqPc.matches) return; // PCのみ
			megaLayer.classList.add('is-active');
			body.classList.add('megamenu-show');
			header.classList.add('hover');
			setPanelState(id);
			};

			const closeMegaPc = () => {
			if (!mqPc.matches) return;
			megaLayer.classList.remove('is-active');
			body.classList.remove('megamenu-show');
			header.classList.remove('hover');
			setPanelState(null);
			};

			// ブラウザ標準の入力候補はメニューの外側に描画される。
			// ただし input 自体はフォーカスを保つため、フォーム操作中は
			// pointer がメガメニュー外に出ても閉じないようにする。
			const closeMegaPcUnlessFocused = () => {
				clearTimeout(hoverTimer);
				hoverTimer = setTimeout(() => {
					if (!megaLayer.matches(':focus-within')) {
						closeMegaPc();
					}
				}, 120);
			};

			// -------- PC hover イベント ----------
			pcTriggers.forEach((btn) => {
			const id = btn.dataset.mega;

			btn.addEventListener('mouseenter', () => {
				if (!mqPc.matches) return;
				clearTimeout(hoverTimer);
				openMegaPc(id);
			});
			});

			header.addEventListener('mouseleave', () => {
			if (!mqPc.matches) return;
			closeMegaPcUnlessFocused();
			});

			megaLayer.addEventListener('mouseleave', () => {
			if (!mqPc.matches) return;
			closeMegaPcUnlessFocused();
			});

			megaLayer.addEventListener('mouseenter', () => {
			if (!mqPc.matches) return;
			clearTimeout(hoverTimer);
			});

			megaLayer.addEventListener('focusin', () => {
				if (!mqPc.matches) return;
				clearTimeout(hoverTimer);
			});

			megaLayer.addEventListener('focusout', () => {
				if (!mqPc.matches) return;
				closeMegaPcUnlessFocused();
			});

			// -------- SP ハンバーガー ----------
			if (hamburger) {
				hamburger.addEventListener('click', () => {
					const willOpen = !megaLayer.classList.contains('is-open');
					megaLayer.classList.toggle('is-open', willOpen);
					hamburger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
					body.classList.toggle('megamenu-show', willOpen);

					// ★ スクロールロックはクラス付け替えだけ
					document.documentElement.classList.toggle('no-scroll', willOpen);
					document.body.classList.toggle('no-scroll', willOpen);

					if (!willOpen) {
					// パネルも閉じたいならここで
					setPanelState(null);
					}
				});
			}

			// -------- SP アコーディオン（.mega-toggle） ----------
			spTriggers.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				if (mqPc.matches) {
				// PCサイズでは .mega-toggle は無視（または必要なら PCでもクリック開閉に使ってもOK）
				return;
				}

				const id = btn.dataset.mega;

				// すでにそのパネルが開いていたら閉じる
				if (currentId === id) {
				setPanelState(null);
				return;
				}

				// 別のパネルを開く
				setPanelState(id);

				// SP での開閉は、megaLayer 自体はすでにハンバーガーで開いている前提
				// （念のため開けておく）
				megaLayer.classList.add('is-open');
				body.classList.add('megamenu-show');
				if (hamburger) {
				hamburger.setAttribute('aria-expanded', 'true');
				}
			});
			});

			// ウィンドウ幅が変わったときの状態リセット（PC/SPまたぐときの保険）
			mqPc.addEventListener('change', () => {
			setPanelState(null);
			megaLayer.classList.remove('is-open', 'is-active');
			body.classList.remove('megamenu-show');
			header.classList.remove('hover');
			if (hamburger) {
				hamburger.setAttribute('aria-expanded', 'false');
			}
			});
		}
	}

	// --------------------------------
	// Category検索：Pre-Owned（USED）商品を除外
	// --------------------------------
	document.querySelectorAll('.category_search[data-exclude-tag]').forEach((form) => {
		form.addEventListener('submit', () => {
			const input = form.querySelector('input[name="q"]');
			const excludedTag = form.dataset.excludeTag;
			if (!input || !excludedTag) return;

			const term = input.value.trim();
			input.value = `${term ? `${term} AND ` : ''}NOT tag:${excludedTag}`;
		});
	});

	// --------------------------------
	// Swiper（メインビジュアル等）
	// --------------------------------
	if (window.Swiper) {
		const mvSwiperEl = document.querySelector('.mainmv');
		if (mvSwiperEl) {
		const mvSwiper = new Swiper(mvSwiperEl, {
			loop: true,
			effect: 'fade',
			speed: 1500,
			autoplay: {
			delay: 4000,
			disableOnInteraction: false,
			},
			navigation: {
			nextEl: '.swiper-btn-next',
			prevEl: '.swiper-btn-prev',
			},
			pagination: {
			el: '.swiper-pagination1',
			clickable: true,
			},
		});
		}
	}
	
	// --------------------------------
	// スクロールアクション
	// --------------------------------
	if (window.gsap && window.ScrollTrigger) {
		const animeTargets = document.querySelectorAll('.scrolls');
		if (animeTargets.length > 0) {
			animeTargets.forEach((animeTarget) => {
			gsap.to(animeTarget, {
				scrollTrigger: {
				trigger: animeTarget,
				start: 'top 120%',
				},
				onComplete: () => {
				animeTarget.classList.add('show');
				},
			});
			});
		}
	}

	// --------------------------------
	// 言語切り替え時のページを維持して言語だけ切り替え
	// --------------------------------
	document.addEventListener('click', function (event) {
		const button = event.target.closest('localization-form button[data-language-code]');
		if (!button) return;

		const localizationForm = button.closest('localization-form');
		if (!localizationForm) return;

		const form = localizationForm.querySelector('form');
		const input = form.querySelector('input[name="language_code"]');

		input.value = button.dataset.languageCode;
		form.submit();
	});

	// --------------------------------
	// footer
    // --------------------------------
	var toggles = document.querySelectorAll('.footer-accordion__toggle');
	toggles.forEach(function (btn) {
		btn.addEventListener('click', function () {
		var expanded = this.getAttribute('aria-expanded') === 'true';
		var panelId = this.getAttribute('aria-controls');
		var panel = document.getElementById(panelId);

		this.setAttribute('aria-expanded', expanded ? 'false' : 'true');

		if (expanded) {
			panel.setAttribute('hidden', 'hidden');
		} else {
			panel.removeAttribute('hidden');
		}
		});
	});
  
	// --------------------------------
	// productページ Swiper
    // --------------------------------
    if (!window.Swiper) return;

	const productpage = document.querySelector('.template-product');
	if (!productpage) return;

	const mainEl = document.querySelector('.product_gallery_main');
	const thumbEl = document.querySelector('.product_gallery_thumbnail');
	if (!mainEl || !thumbEl) return;

	const thumbWrapper = thumbEl.querySelector('.swiper-wrapper');

	// -----------------------------
	// Main Swiper（メインはloop推奨）
	// -----------------------------
	const mainSwiper = new Swiper('.product_gallery_main', {
	spaceBetween: 0,
	effect: 'fade',
	speed: 1000,
	loop: true,
	navigation: {
		nextEl: '.product_gallery_main .nextbtn',
		prevEl: '.product_gallery_main .prevbtn',
	},
	});

	// -----------------------------
	// Thumbs Swiper（SPだけ）
	// -----------------------------
	let thumbSwiper = null;
	const mql = window.matchMedia('(max-width: 767px)');

	function cleanupThumbLoopDom() {
	// loopで作られた複製スライドが残ってる場合の掃除
	thumbEl.querySelectorAll('.swiper-slide-duplicate').forEach((el) => el.remove());

	// wrapper / slides の余計な inline style を掃除
	if (thumbWrapper) thumbWrapper.removeAttribute('style');
	thumbEl.querySelectorAll('.swiper-slide').forEach((slide) => slide.removeAttribute('style'));
	}

	function destroyThumbSwiper() {
	if (!thumbSwiper) {
		cleanupThumbLoopDom();
		return;
	}

	// Swiperがloopを持っている場合は先に壊す（バージョン差異の保険）
	try {
		if (typeof thumbSwiper.loopDestroy === 'function') thumbSwiper.loopDestroy();
	} catch (e) {}

	// destroyでtransformなどを消す（true,trueが重要）
	thumbSwiper.destroy(true, true);
	thumbSwiper = null;

	cleanupThumbLoopDom();
	}

	function initThumbSwiper() {
	if (thumbSwiper) return;

	cleanupThumbLoopDom(); // 初期化前にも一応掃除

	thumbSwiper = new Swiper('.product_gallery_thumbnail', {
		slidesPerView: 'auto',
		spaceBetween: 8,
		freeMode: false,
		watchSlidesProgress: true,

		loop: true,
		// 商品画像が多いこともあるので少し多め（足りないよりマシ）
		loopedSlides: 30,

		// クリック挙動はDOM側で統一するのでfalse
		slideToClickedSlide: false,
	});
	}

	// SP/PC切り替え
	function handleThumbMode() {
	if (mql.matches) {
		// SP
		initThumbSwiper();
		// SPは「左寄せ」挙動を維持したいなら初期位置を合わせる
		if (thumbSwiper) thumbSwiper.slideToLoop(mainSwiper.realIndex, 0);
	} else {
		// PC
		destroyThumbSwiper(); // ★ここが重要：cloneとtransformを消す
	}
	}
	handleThumbMode();
	mql.addEventListener?.('change', handleThumbMode);

	// -----------------------------
	// 共通：サムネクリックでメイン切り替え（PCでも動く）
	// -----------------------------
	function updateThumbActive(realIndex) {
	// clone（duplicate）にはactive付けない
	const thumbs = thumbEl.querySelectorAll('.thumb.swiper-slide:not(.swiper-slide-duplicate)');
	thumbs.forEach((btn) => {
		const i = Number(btn.dataset.index);
		btn.classList.toggle('is-active', i === realIndex);
	});
	}

	thumbEl.addEventListener('click', (e) => {
	const btn = e.target.closest('.thumb');
	if (!btn) return;

	const real = Number(btn.dataset.index);
	if (Number.isNaN(real)) return;

	mainSwiper.slideToLoop(real, 300);

	// SPではサムネも追従
	if (thumbSwiper) {
		thumbSwiper.slideToLoop(real, 300);
	}

	updateThumbActive(real);
	});

	// メイン変更時の追従
	mainSwiper.on('slideChange', () => {
	const real = mainSwiper.realIndex;
	updateThumbActive(real);

	if (thumbSwiper) thumbSwiper.slideToLoop(real, 300);
	});

	// 初期active
	updateThumbActive(mainSwiper.realIndex);

	// -----------------------------
	// サムネ高さ同期（既存）
	// -----------------------------
	function syncThumbHeight() {
	const main = document.querySelector('.product_gallery_main');
	const thumb = document.querySelector('.product_gallery_thumbnail');
	if (!main || !thumb) return;

	const mainHeight = main.offsetHeight;
	thumb.style.setProperty('--thumb-height', `${mainHeight}px`);
	}
	window.addEventListener('load', syncThumbHeight);
	window.addEventListener('resize', syncThumbHeight);
	mainSwiper.on('resize', syncThumbHeight);
	mainSwiper.on('update', syncThumbHeight);

	// -----------------------------
	// Sizeのgrid-template-columnに個数変数代入（既存）
	// -----------------------------
	const productSize = document.querySelector('.product_item_size_kikaku');
	if (productSize) {
	const count = productSize.querySelectorAll('.kikaku_select').length;
	productSize.style.setProperty('--size-num', count);
	}

	// =============================
	// モーダル側 Swiper（既存）
	// =============================
	const modalEl = document.querySelector('.product_modal_swiper');
	let modalSwiper = null;

	if (modalEl) {
	modalSwiper = new Swiper('.product_modal_swiper', {
		loop: true,
		navigation: {
		nextEl: '.product_modal_next',
		prevEl: '.product_modal_prev',
		},
	});
	}

	const modal = document.getElementById('productModal');
	const body = document.body;

	if (modal && modalSwiper) {
	document.querySelectorAll('.product_gallery_main .swiper-slide img').forEach((img, index) => {
		img.addEventListener('click', () => {
		modal.classList.add('is-open');
		body.style.overflow = 'hidden';
		modalSwiper.slideToLoop(index, 0);
		});
	});

	document.querySelectorAll('.js-modal-close').forEach((el) => {
		el.addEventListener('click', () => {
		modal.classList.remove('is-open');
		body.style.overflow = '';
		});
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
		modal.classList.remove('is-open');
		body.style.overflow = '';
		}
	});
	}


    //
    // 商品規格（サイズ）ボタンクリック → variant切り替え & URL更新
    document.addEventListener('click', function (e) {
        // .product_item_size_kikaku 内の .kikaku_select がクリックされたときだけ反応
        const btn = e.target.closest('.product_item_size_kikaku .kikaku_select');
        if (!btn) return;

        e.preventDefault(); // 念のため

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        // 一番近い form を取得
        const form = btn.closest('form');
        if (!form) return;

        // form 内の select[name="id"] を取得
        const select = form.querySelector('select[name="id"]');
        if (!select) return;

        // 1. select の値を書き換え
        select.value = variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        // 2. 同じブロック内のボタンの .selected を付け替え
        const wrapper = btn.closest('.product_item_size_kikaku');
        if (wrapper) {
        const allBtns = wrapper.querySelectorAll('.kikaku_select');
        allBtns.forEach((b) => {
            b.classList.toggle('selected', b === btn);
        });
        }

        // 3. URL の ?variant= を更新
        if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
        }
    });
});
